import React, { Fragment, useState } from "react";
import { Image, Button, Table } from "react-bootstrap";
import moment from "moment";
import CallingButtonPopup from "../../allPopupReusable/CallingButtonPopup";
import SendSmsButton from "../../allPopupReusable/SendSmsButton";
import NotificationButton from "../../allPopupReusable/NotificationButton";
import { NavLink, useHistory } from "react-router-dom";
// import { PopupIconButtonReusable } from "../../allPopupReusable/allPopupReusableIconButton/PopupIconButtonReusable";
// import ViewButtonPopup from "../../allPopupReusable/ViewButtonPopup";
// import EditDiner from "../../allPopupReusable/editDinerAndEditReservaion/EditDiner";
import EditDiner from "../../../vendorDashboardComponents/seatingDashboard/EditDiner";
import DeletePopup from "../../allPopupReusable/smallPopup/DeletePopup";
import LocationReusable from "../../allPopupReusable/locationReusablePopup/LocationReusable";
import ChatWindow from "../../../vendorDashboardComponents/seatingDashboard/seatingDashboard/ChatWindow";
import EditWaitTime from "../../allPopupReusable/tableNumberPopup/EditWaitTime";
// import EditReservation from "../../allPopupReusable/editDinerAndEditReservaion/EditReservation";
import { EventCountDownTimer } from "../../allPopupReusable/tableNumberPopup/EventCountDownTimer";
import ViewDiner from "../../../vendorDashboardComponents/seatingDashboard/ViewDiner";
// import { EditDiner } from "../../allPopupReusable/editDinerAndEditReservaion/EditDiner";
import EnterTableNumber from "../../allPopupReusable/tableNumberPopup/EnterTableNumber";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import Alert from "react-s-alert";
import { TableGridViewLeft } from "../seatingDashboardTable/SeatingDashboardBody";
import {
  change_table_status_table_management,
  vendor_seated_waittime_request,
} from "../../../../store/actions/dashboardAction/addingAction";
import CallingIconButtonActionFile from "../../allPopupReusable/tableNumberPopup/CallingIconButtonAction/CallingIconButtonActionFile";

export const ReservationDashboardBody = ({
  orderType,
  displayCall,
  displaySms,
  displayNotification,
  displayChat,
  displayViewDiner,
  displayEditDiner,
  totalCount,
  totalAdult,
  totalKids,
  totalHighchair,
  totalHandicapped,
  name,
  sendDataDinerProps,
  time,
  ...props
}) => {
  const currentTime = new Date();
  var endTime = moment(currentTime).format("YYYY-MM-DDTHH:mm");
  const createdAt = new Date(props.dinerInfo.createdAt);
  var startTime = moment(createdAt).format("YYYY-MM-DDTHH:mm");

  let dateOne = new Date(startTime);
  let dateTwo = new Date(endTime);

  let msDifference = dateTwo - dateOne;
  let minutes = Math.floor(msDifference / 1000 / 60);

  function time_convert(minutes) {
    var hours = Math.floor(minutes / 60);
    var nMinutes = minutes % 60;
    return hours + " HH : " + nMinutes + " min";
  }

  const updatedTime = new Date(
    props?.dinerInfo?.wait_time !== undefined
      ? props?.dinerInfo?.wait_time_date
      : props?.dinerInfo?.reservationTime
  );
  const currentTimeTwo = new Date().getTime();
  const updatedTimeNew = updatedTime.getTime();
  const waitTime =
    props?.dinerInfo?.wait_time !== undefined
      ? props?.dinerInfo?.wait_time * 60 * 1000
      : 0;
  let updateWaitTime = updatedTimeNew + waitTime;
  let diff = updateWaitTime - currentTimeTwo;

  const seatedTime = new Date(props.dinerInfo.seatedTime);
  var endSeatedTime = moment(seatedTime).format("YYYY-MM-DDTHH:mm");
  var startTimeNew = moment(createdAt).format("YYYY-MM-DDTHH:mm");
  let dateOneSeated = new Date(startTimeNew);
  let dateTwoSeated = new Date(endSeatedTime);

  let msDifferenceSeated = dateTwoSeated - dateOneSeated;
  let minutesSeated = Math.floor(msDifferenceSeated / 1000 / 60);

  function seated_time_difference(minutesSeated) {
    var hours = Math.floor(minutesSeated / 60);
    var nMinutesSeated = minutesSeated % 60;
    return hours + " HH : " + nMinutesSeated + " min";
  }

  const [TrDetail, setTrDetail] = useState({ TrDetail: false });
  const showTr = () => setTrDetail({ TrDetail: !TrDetail.TrDetail });

  let vendorId = JSON.parse(localStorage.getItem("vendorId"));
  let subscriptionId = JSON.parse(localStorage.getItem("subscriptionId"));

  const onSubmitHandlerAssignTable = (e) => {
    e.preventDefault();
    if (
      props.tableSelected &&
      props.tableSelected.pax_value &&
      props.tableSelected.table_number
    ) {
      if (
        props.dinerInfo.adult_count + props.dinerInfo.kids_count <=
        props.tableSelected.pax_value
      ) {
        const token = props.auth.user.accessToken;
        const diner_id = props.dinerInfo._id;
        const vendor_id = props.auth.user.VendorUser._id;
        const formData = {
          table_number: props.tableSelected.table_number,
          diner_status: "SEATED",
          wait_time: parseInt(0),
          seatedTime: new Date().getTime(),
          vendor: vendor_id,
        };
        props.change_table_status_table_management(
          props.actionPerformBy === "ADMIN"
            ? subscriptionId
            : props.actionPerformBy === "ADMIN"
            ? subscriptionId
            : props.subscription_id,
          props.tableSelected.table_number,
          "OCCUPIED",
          token,
          vendor_id
        );
        // console.log(token, diner_id, vendor_id, formData);
        props.vendor_seated_waittime_request(
          formData,
          diner_id,
          vendor_id,
          token,
          onCallBackFunc
        );
      } else {
        Alert.warning(`<h4>Please check the required pax.</h4>`, {
          position: "top-right",
          effect: "bouncyflip",
          beep: true,
          html: true,
          timeout: 3000,
          offset: 35,
        });
      }
    } else {
      Alert.warning(`<h4>Please select a table.</h4>`, {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 3000,
        offset: 35,
      });
    }
  };

  const onCallBackFunc = (e) => {
    if (props?.setTableSelected) props.setTableSelected("reset");
    return Alert.success(`<h4>Table assigned successfully</h4>`, {
      position: "top-right",
      effect: "bouncyflip",
      beep: true,
      html: true,
      timeout: 3000,
      offset: 35,
    });
  };
  const [open, setState] = useState(false);
  const onCloseModal = () => {
    setState(!open);
  };

  const [enterTableModal, setEnterTableModal] = useState(false);
  const setTablePopUp = (e) => {
    setEnterTableModal(true);
  };
  const setTablePopUpClose = (e) => {
    setEnterTableModal(false);
  };
  const [editWaitTimeModel, seteditWaitTimeModel] = useState(false);
  const changeEditWaitTimeModel = () => seteditWaitTimeModel(false);
  const openEditWaitTimeModel = () => seteditWaitTimeModel(true);

  const history = useHistory();

  return (
    <Fragment>
      {/* <div className="seating-dashboard-desktop-body-time">
        <h4>{props.time}</h4>
      </div> */}
      {/* <div className="col-12 p-0 today-date-dropdown-seating-dashboard">
        <div>
          <h4>{moment().format("hh:mm A")}</h4>
        </div>
        <div className="seating-dashboard-today-line">
          <hr className="line" />
        </div>
      </div> */}
      <Table>
        <tbody className="w-100 seating-dashboard-body-new">
          <tr className="w-100 p-0">
            <td className="p-0 w-100">
              <table className="w-100">
                <tbody className="sd_body_css">
                  <tr
                    className={`cursor enGrayBorderBox sd_body_tr ${
                      props.dinerInfo.service_type === "RESERVATION"
                        ? "td_b_o"
                        : "td_b_g"
                    }`}
                    onClick={showTr}
                  >
                    <td
                      className={`${
                        props &&
                        props.dinerInfo &&
                        props.dinerInfo.userConfirmed === true
                          ? `td_b_g `
                          : `td_b_o `
                      } ${props.displayGrid ? `order-type-Image` : ""}`}
                      style={{ width: "6%" }}
                    >
                      {props.dinerInfo.isWalkIn === true &&
                      props.dinerInfo.service_type === "SEATING" ? (
                        <Image
                          src={require("../../../../assets/images/ActionImages/image/walkin.svg")}
                          alt="Order Type"
                          title="Order Type"
                        />
                      ) : null ||
                        (props.dinerInfo.isWalkIn === false &&
                          props.dinerInfo.service_type === "SEATING") ? (
                        <Image
                          src={require("../../../../assets/images/ActionImages/image/waitlist.svg")}
                          alt="Order Type"
                          title="Order Type"
                        />
                      ) : null ||
                        props.dinerInfo.service_type === "RESERVATION" ? (
                        <Image
                          src={require("../../../../assets/images/ActionImages/image/reservation.svg")}
                          alt="Order Type"
                          title="Order Type"
                        />
                      ) : null}
                    </td>
                    <td style={{ width: !props.displayGrid ? "25%" : "20%" }}>
                      <h4 className="font_20_m">{props.dinerName}</h4>
                      <p className="font_12_r">#{props.dinerInfo.diner_id}</p>
                      {props.dinerInfo?.cross_ref_id !== null &&
                      props.dinerInfo?.cross_ref_id !== undefined ? (
                        <>
                          {props.dinerInfo &&
                          props.dinerInfo?.service_type === "RESERVATION" &&
                          props.dinerInfo?.cross_ref_id?.order_id ? (
                            <NavLink
                              to="/orderdashboard/3"
                              className="f9-400"
                              style={{ color: "#2196F3" }}
                            >
                              #{props.dinerInfo?.cross_ref_id?.order_id}
                            </NavLink>
                          ) : (
                            ""
                          )}
                        </>
                      ) : null}
                    </td>
                    <td style={{ width: !props.displayGrid ? "35%" : "12%" }}>
                      <div className="total-pax-body">
                        <div className="col d-flex p-0">
                          <div className="total-pax-body-inside">
                            <h4 className="font_24_b">
                              {props.dinerInfo.adult_count +
                                props.dinerInfo.kids_count}
                            </h4>
                            {/* <p className="total-pax-light-text">PAX</p> */}
                          </div>
                          <div className="total-adult-kids">
                            {props.dinerInfo.adult_count === 0 ? null : (
                              <div className="display-align">
                                <Image
                                  src={require("../../../../assets/images/ActionImages/image/adult.svg")}
                                  alt="Adult"
                                  title="Adult"
                                  className="pax-type-Image"
                                />
                                <p className="font_12_m ml-1 mr-1">
                                  {props.dinerInfo.adult_count}
                                </p>
                              </div>
                            )}
                            {props.dinerInfo.kids_count === 0 ? null : (
                              <div className="display-align">
                                <Image
                                  src={require("../../../../assets/images/ActionImages/image/kids.svg")}
                                  alt="Kids"
                                  title="Kids"
                                  className="pax-type-Image"
                                />
                                <p className="font_12_m ml-1 mr-1">
                                  {props.dinerInfo.kids_count}
                                </p>
                              </div>
                            )}
                          </div>
                          <div className="total-highchair-handicapp">
                            {props.dinerInfo.high_chair === 0 ? null : (
                              <div className="display-align">
                                <Image
                                  src={require("../../../../assets/images/ActionImages/image/highchair.svg")}
                                  alt="Highchair"
                                  title="Highchair"
                                  className="pax-type-Image"
                                />
                                <p className="font_12_m ml-1 mr-1">
                                  {props.dinerInfo.high_chair}
                                </p>
                              </div>
                            )}
                            {props.dinerInfo.handicap_chair === 0 ? null : (
                              <div className="display-align">
                                <Image
                                  src={require("../../../../assets/images/ActionImages/image/handicap.svg")}
                                  alt="Handicapped"
                                  title="Handicapped"
                                  className="pax-type-Image"
                                />
                                <p className="font_12_m ml-1 mr-1">
                                  {props.dinerInfo.handicap_chair}
                                </p>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </td>
                    <td
                      style={{ width: !props.displayGrid ? "34%" : "15%" }}
                      onClick={(e) => {
                        if (!e) var e = window.event;
                        e.cancelBubble = true;
                        if (e.stopPropagation) e.stopPropagation();
                      }}
                    >
                      <div className="date-time-timer-body">
                        <div className="time-and-edit-button">
                          {moment(props?.dinerInfo?.reservationTime).format(
                            "DD-MM-YYYY"
                          ) === moment().format("DD-MM-YYYY") ? (
                            <EditWaitTime
                              allDataProps={props.dinerInfo._id}
                              noDisplay={
                                <div className="timer-section mr-2">
                                  <h4
                                    className="f14-700"
                                    style={{ color: "#EE3A23" }}
                                    //timer-count
                                  >
                                    <EventCountDownTimer waitNew={diff} />
                                  </h4>
                                </div>
                              }
                              openFromParent={changeEditWaitTimeModel}
                              changeEditWaitTimeModel={changeEditWaitTimeModel}
                            />
                          ) : (
                            <div className="timer-section mr-2">
                              <h4
                                className="f14-700"
                                style={{ color: "#EE3A23" }}
                                //timer-count
                              >
                                <EventCountDownTimer waitNew={diff} />
                              </h4>
                            </div>
                          )}
                        </div>
                      </div>
                      <p className="font_20_r">
                        {props.dinerInfo.service_type === "RESERVATION"
                          ? moment(props.dinerInfo.reservationTime).format(
                              "Do MMM YYYY"
                            )
                          : moment(props.dinerInfo.createdAt).format(
                              "Do MMM YYYY"
                            )}
                      </p>
                      <p className="font_20_r">
                        {props.dinerInfo.service_type === "RESERVATION"
                          ? moment(props.dinerInfo.reservationTime).format(
                              "hh:mm A"
                            )
                          : moment(props.dinerInfo.createdAt).format("hh:mm A")}
                      </p>
                    </td>
                    {props.displayGrid && (
                      <>
                        <td style={{ width: "15%" }}>
                          <h4 className="font_20_m">
                            {props.dinerInfo.seating_preference[0]}
                          </h4>
                        </td>
                        <td style={{ width: "15%" }}>
                          <h4 className="font_20_m">
                            {props.dinerInfo.diner_status === "NOTSEATED"
                              ? time_convert(minutes)
                              : seated_time_difference(minutesSeated)}
                          </h4>
                        </td>
                        <td style={{ width: "32%" }}>
                          <div
                            className={
                              props.displayButton === true
                                ? "action-section-body d-flex align-items-center justify-content-center"
                                : "action-section-body f10-500 align-items-center"
                            }
                          >
                            {props.dinerInfo.diner_status === "SEATED" ? (
                              props.displayInfo === "SUPERADMIN" ? (
                                ""
                              ) : (
                                <div>
                                  <DeletePopup
                                    buttonDisplay="smallCancelButton"
                                    displayPopup="seatingUnseated"
                                    buttonText="Unseat"
                                    bigText="Request Unseat"
                                    display={true}
                                    reasonText="Are you sure to Unseat ?"
                                    dataSend={props.dinerInfo}
                                    actionBy={props.actionPerformBy}
                                    pathAction="HISTORY"
                                    adminSendVendorId={vendorId}
                                    IconButton={require("../../../../assets/images/iconButton/backarrowred.svg")}
                                  />
                                </div>
                              )
                            ) : props.displayInfo === "SUPERADMIN" ? (
                              ""
                            ) : (
                              <div>
                                <DeletePopup
                                  buttonDisplay="smallCancelButton"
                                  displayPopup="resonFforCancellation"
                                  actionCall={"seatingDashboardSide"}
                                  buttonText="Cancel"
                                  bigText="Request Cancel"
                                  reasonText="Are you sure to Cancel ?"
                                  dataSend={props.dinerInfo._id}
                                  actionBy={props.actionPerformBy}
                                  pathAction="HISTORY"
                                  adminSendVendorId={vendorId}
                                  IconButton={require("../../../../assets/images/iconButton/crossred.svg")}
                                />
                              </div>
                            )}
                            <div className="middle-timer m-0">
                              {/* <p className="font_12_r mb-2">Total Wait time</p> */}
                              <div
                                className="count-down-timer"
                                style={{
                                  backgroundColor: `${
                                    props.dinerInfo.diner_status === "NOTSEATED"
                                      ? "#FFF6DF"
                                      : "#E6FFDF"
                                  }`,
                                }}
                              >
                                {/* <i
                              className="fa fa-hourglass-half mr-3"
                              aria-hidden="true"
                            ></i> */}
                                <p
                                  className="font_16_m"
                                  style={{
                                    color: `${
                                      props.dinerInfo.diner_status ===
                                      "NOTSEATED"
                                        ? "#E2A200"
                                        : "#25A900"
                                    }`,
                                  }}
                                >
                                  {/* {props.dinerInfo.diner_status === "NOTSEATED"
                                ? time_convert(minutes)
                                : seated_time_difference(minutesSeated)} */}
                                  {props.dinerInfo.diner_status === "NOTSEATED"
                                    ? "Not seated"
                                    : "Seated"}
                                </p>
                              </div>
                              {/* <p className="font_16_r">
                            Status:&nbsp;
                            <span className="font_16_b">
                              {props.dinerInfo.diner_status === "NOTSEATED"
                                ? "NOT SEATED"
                                : "SEATED"}
                            </span>
                          </p> */}
                            </div>
                            {moment(new Date()).format("YYYY-MM-DD") >=
                            moment(props.dinerInfo.reservationTime).format(
                              "YYYY-MM-DD"
                            ) ? (
                              props.dinerInfo.diner_status === "SEATED" ? (
                                props.displayInfo === "SUPERADMIN" ? (
                                  ""
                                ) : (
                                  <div>
                                    <DeletePopup
                                      buttonDisplay="smallSaveButton"
                                      displayPopup="seatingCompleted"
                                      buttonText="Complete"
                                      bigText="Request Completed"
                                      reasonText="Are you sure to Completed ?"
                                      // bigText="Are you sure to Completed ?"
                                      dataSend={props.dinerInfo}
                                      actionBy={props.actionPerformBy}
                                      pathAction="HISTORY"
                                      adminSendVendorId={vendorId}
                                      IconButton={require("../../../../assets/images/iconButton/Nextarrowgreen.svg")}
                                    />
                                  </div>
                                )
                              ) : props.displayInfo === "SUPERADMIN" ? (
                                ""
                              ) : (
                                <div>
                                  <EnterTableNumber
                                    buttonText="Seat"
                                    enterTableModal={enterTableModal}
                                    closedMainModal={onCloseModal}
                                    setTablePopUp={setTablePopUp}
                                    setTablePopUpClose={setTablePopUpClose}
                                    allDataProps={props.dinerInfo?._id}
                                    wholeDataObj={props.dinerInfo}
                                    IconButton={require("../../../../assets/images/iconButton/Nextarrowgreen.svg")}
                                  />
                                </div>
                              )
                            ) : null}
                          </div>
                        </td>
                      </>
                    )}
                  </tr>
                  {TrDetail.TrDetail && (
                    <tr className="sd_accordion_body">
                      {!props.displayGrid ? (
                        <TableGridViewLeft
                          onSubmitHandlerAssignTable={
                            onSubmitHandlerAssignTable
                          }
                          subscription_id={
                            props.actionPerformBy === "ADMIN"
                              ? subscriptionId
                              : props.subscription_id
                          }
                          tableSelected={props.tableSelected}
                          dinerInfo={props.dinerInfo}
                          onCloseModal={onCloseModal}
                          time_convert={time_convert}
                          seated_time_difference={seated_time_difference}
                          minutes={minutes}
                          minutesSeated={minutesSeated}
                          displayCall={props.displayCall}
                          displaySms={props.displaySms}
                          displayNotification={props.displayNotification}
                          displayChat={props.displayChat}
                          openChatWindow={props.openChatWindow}
                          displayViewDiner={props.displayViewDiner}
                          displayEditDiner={props.displayEditDiner}
                          onClosedAction={onCloseModal}
                          diff={diff}
                          changeEditWaitTimeModel={changeEditWaitTimeModel}
                        />
                      ) : (
                        <>
                          <td className="sd_accordion_td_1">
                            <h4 className="font_20_m c_red">More details</h4>
                            <div className="d-flex justify-content-between mt-3 mr-3">
                              {displayCall === true ? (
                                // <CallingButtonPopup
                                //   buttonClass="smallButton"
                                //   sendData={props.dinerInfo}
                                // />
                                <CallingIconButtonActionFile
                                  orderDetails={props.dinerInfo?.user_details}
                                  actionType="conbinedName"
                                />
                              ) : null}
                              {displaySms === true ? (
                                <SendSmsButton
                                  dataSend={props.dinerInfo}
                                  buttonClass="smallButton"
                                />
                              ) : null}
                              {displayNotification === true ? (
                                <NotificationButton
                                  buttonClass="smallButton"
                                  dataSend={props.dinerInfo}
                                />
                              ) : null}
                              {displayChat === true ? (
                                <ChatWindow
                                  data={props.dinerInfo}
                                  text={props.actionBy}
                                />
                              ) : null}
                              {displayViewDiner === true ? (
                                // <ViewButtonPopup
                                //   dataSend={props.dinerInfo}
                                //   buttonClass="smallButton"
                                // />
                                <ViewDiner
                                  dataSend={props.dinerInfo}
                                  setEnterTableModalProp={(e) =>
                                    setTablePopUp()
                                  }
                                  displayData={props.displayInfo}
                                  displayButton="RESERVATION"
                                  viewActionPerformBy={props.actionPerformBy}
                                  viewVendorId={vendorId}
                                  subscription_id={
                                    props.actionPerformBy === "ADMIN"
                                      ? subscriptionId
                                      : props.subscription_id
                                  }
                                  socket={props.socket}
                                  diff={diff}
                                  changeEditWaitTimeModel={
                                    changeEditWaitTimeModel
                                  }
                                  auth={props.auth.user?.VendorUser?.role}
                                />
                              ) : null}
                              {displayEditDiner === true ? (
                                <Button
                                  variant="link"
                                  className="enIconBtn mr-3"
                                  onClick={() =>
                                    history.push({
                                      pathname: `/seatingdashboard/editdiner/${props.dinerInfo?.diner_id}`,
                                      state: { dinerInfo: props.dinerInfo },
                                    })
                                  }
                                >
                                  <Image
                                    src={require("../../../../assets/images/UserManagement/pencil.svg")}
                                    alt="Edit"
                                    title="Edit"
                                    fluid
                                  />
                                </Button>
                              ) : // <EditDiner
                              //   actionByData={props.actionBy}
                              //   buttonClass="smallButton"
                              //   dataSend={props.dinerInfo}
                              //   bigText="Edit Diner"
                              //   displayData={props.displayInfo}
                              //   displayButton="RESERVATION"
                              //   viewActionPerformBy={props.actionPerformBy}
                              //   viewVendorId={vendorId}
                              //   subscription_id={
                              //     props.actionPerformBy === "ADMIN"
                              //       ? subscriptionId
                              //       : props.subscription_id
                              //   }
                              //   diff={diff}
                              //   changeEditWaitTimeModel={
                              //     changeEditWaitTimeModel
                              //   }
                              // />
                              null}
                            </div>
                          </td>
                          <td className="sd_accordion_td_2">
                            {props.auth.user?.VendorUser?.role !== "vendor" ? (
                              <></>
                            ) : (
                              <>
                                <h4 className="font_20_m">
                                  Track User Location
                                </h4>
                                <LocationReusable
                                  dataSend={props.dinerInfo}
                                  disabled={
                                    props.dinerInfo.service_type ===
                                      "RESERVATION" &&
                                    moment(
                                      props.dinerInfo.reservationTime
                                    ).format("Do MMM YYYY") !==
                                      moment().format("Do MMM YYYY")
                                      ? true
                                      : false
                                  }
                                />
                              </>
                            )}
                          </td>
                          <td className="sd_accordion_td_3">
                            <h4 className="font_20_m">Date & Time</h4>
                            <div className="mt-3">
                              <p className="font_16_r">
                                {props.dinerInfo.service_type === "RESERVATION"
                                  ? moment(
                                      props.dinerInfo.reservationTime
                                    ).format("Do MMM YYYY")
                                  : moment(props.dinerInfo.createdAt).format(
                                      "Do MMM YYYY"
                                    )}
                              </p>
                              <p className="font_16_r">
                                {props.dinerInfo.service_type === "RESERVATION"
                                  ? moment(
                                      props.dinerInfo.reservationTime
                                    ).format("hh:mm A")
                                  : moment(props.dinerInfo.createdAt).format(
                                      "hh:mm A"
                                    )}
                              </p>
                            </div>
                          </td>
                          <td className="sd_accordion_td_4">
                            <h4 className="font_20_m">Table / Room No.</h4>
                            <div className="mt-3">
                              <p className="font_16_r">
                                {props?.dinerInfo?.room_number === null ||
                                props?.dinerInfo?.room_number === undefined ||
                                props?.dinerInfo?.room_number === ""
                                  ? ""
                                  : `Room No. - ${props?.dinerInfo?.room_number}`}
                              </p>
                              <p className="font_16_r">
                                {props?.dinerInfo?.table_number === null ||
                                props?.dinerInfo?.table_number === undefined ||
                                props?.dinerInfo?.table_number === ""
                                  ? ""
                                  : `Table No. - ${props?.dinerInfo?.table_number}`}
                              </p>
                            </div>
                          </td>
                          <td className="sd_accordion_td_5">
                            <h4 className="font_20_m">Special Occasion</h4>
                            <div className="d-flex mt-3">
                              <p
                                className="font_16_r"
                                style={{ wordBreak: "break-word" }}
                              >
                                {props.dinerInfo.occasion}
                                {/* {props.dinerInfo.occasion.length > 65 ? (
                              <span className="c_orange">&nbsp;see more</span>
                            ) : (
                              ""
                            )} */}
                              </p>
                            </div>
                          </td>
                          <td className="sd_accordion_td_6">
                            <h4 className="font_20_m">Status</h4>
                            <div className="d-flex mt-3">
                              <div className="b_c_orange status_blink_box"></div>
                              <p className="font_16_m">
                                {props.dinerInfo.diner_status}
                              </p>
                            </div>
                          </td>
                        </>
                      )}
                    </tr>
                  )}
                </tbody>
              </table>
            </td>
          </tr>
        </tbody>
      </Table>
    </Fragment>
  );
};

ReservationDashboardBody.propTypes = {
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  // subscription_id: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors.errors,
  subscription_id:
    state.onboarding &&
    state.onboarding.onboard_subscription_details &&
    state.onboarding.onboard_subscription_details._id,
});

export default connect(mapStateToProps, {
  // clear_all_errors,
  vendor_seated_waittime_request,
  // update_new_subscription_for_vendor,
  change_table_status_table_management,
})(withRouter(ReservationDashboardBody));
